import type { MouseEvent } from 'react'

/**
 * The veil of a choice over the chat closes it on a tap (1.126.0).
 *
 * `.bogen` lets taps through to what lies below, because under the point's
 * form the map must stay movable. A choice over the chat has nothing below to
 * move -- and from use, on the iPad: with "Zu einem Tag springen" open, the
 * pill above it could still be tapped, and "Zu einem Tag der Reise springen"
 * opened on top. So such a sheet carries `bogen--schliesst` (the veil takes
 * the taps) and this handler (a tap on the veil, not on the sheet, closes).
 *
 * One place for what stood once in `Chatfilter` and would have stood three
 * more times. The event stops here: the sheet is a portal, and React would
 * carry the tap up to whatever holds it.
 */
export function veilCloses(onClose: () => void): (event: MouseEvent<HTMLElement>) => void {
  return (event) => {
    if (event.target !== event.currentTarget) return
    event.stopPropagation()
    onClose()
  }
}
